export default __webpack_public_path__ + "static/media/couchdb.4c527147.svg";